import { Dispatch, RefObject, SetStateAction, useEffect } from 'react';

export const useCloseOnScroll = (
  open: boolean,
  setOpen: Dispatch<SetStateAction<boolean>>,
  anchorRef: RefObject<HTMLElement>,
): void => {
  useEffect(() => {
    if (!open) return undefined;

    const handleScroll = () => {
      const anchor = anchorRef.current;
      if (!anchor) return;

      const rect = anchor.getBoundingClientRect();
      const header = document.querySelector<HTMLElement>('[data-testid="header-test"]');
      const topBoundary = header?.getBoundingClientRect().bottom || 80;
      const isVisible = rect.bottom > topBoundary
        && rect.top < window.innerHeight
        && rect.right > 0
        && rect.left < window.innerWidth;

      if (!isVisible) setOpen(false);
    };
    window.addEventListener('scroll', handleScroll, true);

    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [anchorRef, open, setOpen]);
};
